import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ApplicationService } from '@picard/services-lib';
import { Title } from '@angular/platform-browser';
import { StorageConstants } from '@picard/shared-lib';
import { PreAuthenticationResponse } from '@picard/models-lib';
import { NavigationEnd, Router } from '@angular/router';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  //#endregion Properties

  //#region Constructor
  constructor(private _applicationService: ApplicationService, private _title: Title, private _router: Router) {
  }
  //#endregion Constructor

  //#region Functions
  loadGoogleAnalyticsScript(shortcode: string, ga_measurementId: string) {
    let node = document.createElement('script'); // creates the script tag
    node.src = `https://www.googletagmanager.com/gtag/js?id=${ga_measurementId}`; // sets the source (insert url in between quotes)
    node.type = 'text/javascript'; // set the script type
    node.async = true; // makes script run asynchronously
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node); 

    let node2 = document.createElement('script'); // creates the script tag
    node2.src = `../assets/analytics/${shortcode}.js`; // sets the source (insert url in between quotes)
    node2.type = 'text/javascript'; // set the script type

    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node2); 
  }

  ngOnInit() {
    const preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
    if (preAuthJson) {
      this.preAuthenticationResponse = JSON.parse(preAuthJson);
      this._title.setTitle(this.preAuthenticationResponse.description);
      
      if (this.preAuthenticationResponse.code === 'coffee') {
        var shortCode = this.preAuthenticationResponse.code;
        var ga_measurementId = 'G-XZXCLKEG0N';
        this.loadGoogleAnalyticsScript(shortCode, ga_measurementId);
      }else if (this.preAuthenticationResponse.code === 'pauls') {
        var shortCode = this.preAuthenticationResponse.code;
        var ga_measurementId = 'G-721KZ3F06Y';
        this.loadGoogleAnalyticsScript(shortCode, ga_measurementId);
      }else if (this.preAuthenticationResponse.code === 'norman') {
        var shortCode = this.preAuthenticationResponse.code;
        var ga_measurementId = 'G-6WWR2X9JTH';
        this.loadGoogleAnalyticsScript(shortCode, ga_measurementId);
      }else if (this.preAuthenticationResponse.code === 'motherland') {
        var shortCode = this.preAuthenticationResponse.code;
        var ga_measurementId = 'G-XGDMYNXGPM';
        this.loadGoogleAnalyticsScript(shortCode, ga_measurementId);
      }
    } else {
      this._title.setTitle('ElectronicLine-PiCard Loyalty');
      
      var domain = window.location.href;
      domain = domain.replace("https://", "");
      domain = domain.substring(0, domain.indexOf(".toget.me"));
      //console.log('domain-name: '+domain);
      
      if (domain === 'coffee') {
        var ga_measurementId = 'G-XZXCLKEG0N';
        this.loadGoogleAnalyticsScript(domain, ga_measurementId);
      }else if (domain === 'pauls') {
        var ga_measurementId = 'G-721KZ3F06Y';
        this.loadGoogleAnalyticsScript(domain, ga_measurementId);
      }else if (domain === 'norman') {
        var ga_measurementId = 'G-6WWR2X9JTH';
        this.loadGoogleAnalyticsScript(domain, ga_measurementId);
      }else if (domain === 'motherland') {
        var ga_measurementId = 'G-XGDMYNXGPM';
        this.loadGoogleAnalyticsScript(domain, ga_measurementId);
      }
    }
    this._applicationService.setFavIcon();
    // ToDo: Add route column (programme table)
  }
  ngAfterViewInit() {}
  //#endregion Functions
}
